function ConfirmedBooking() {
  return (
    <div style={{textAlign:"center",marginTop:"120px"}}>

      <h1>✅ Booking Confirmed</h1>

      <p>
        Thank you for reserving a table at Little Lemon.
      </p>

      <p>
        We look forward to serving you!
      </p>

    </div>
  );
}

export default ConfirmedBooking;